<noscript>
    <img
        class="w-full"
        [ngClass]="additionalClasses"
        [src]="defaultSrc || ''"
        [alt]="altText"
        loading="lazy" />
</noscript>
<img
    #imageElement
    class="blur-up lazyload w-full"
    [attr.data-src]="defaultSrc || ''"
    [attr.data-srcset]="srcSet || ''"
    [src]="svgPlaceholder || ''"
    [alt]="altText || ''"
    [ngClass]="additionalClasses" />
